import Title from '../components/elements/title';
import SubTitle from '../components/elements/sub-title';
import UnorderedList from '../components/elements/unordered-list';

export const CookiePolicyFr = () => {
  return (
    <div>
      <Title>Cookies</Title>
      <p className="my-2">Dernière mise à jour le 27 décembre 2021</p>
      <p>
        Pour vous offrir un meilleur service lors de votre visite sur les sites web, la plupart des sites utilisent des
        cookies. Ce sont des techniques utiles qui collectent et utilisent des informations, rendant ainsi les sites web
        plus faciles à utiliser.
      </p>
      <SubTitle>Qu'est-ce que les Cookies</SubTitle>
      <p className="my-4">
        Par exemple, les cookies vous permettent de rester connecté à un site web ou de mémoriser vos préférences,
        telles que les paramètres de localisation et de langue. De plus, lors de vos achats en ligne, ils conservent
        votre panier d'achat numérique. Les propriétaires de sites web peuvent également, grâce aux cookies, savoir
        combien de fois leurs sites - et quelles pages - sont consultés par les visiteurs.
      </p>
      <p className="my-4">
        Les cookies sont de petits fichiers texte qu'un site web place sur le disque dur de votre ordinateur lorsque
        vous visitez le site. Vous pouvez les supprimer à tout moment, ce qui est très simple à faire via les paramètres
        de votre navigateur. Gardez à l'esprit que, après avoir supprimé les cookies, vous devrez peut-être
        réinitialiser vos préférences ou vous reconnecter.
      </p>
      <p className="my-4">
        Il est important de noter que l'utilisation des cookies est sécurisée. Les cookies ne sont pas la cause
        d'e-mails indésirables ni d'actions de télémarketing. En effet, les cookies ne stockent ni votre adresse e-mail
        ni votre numéro de téléphone, et ils ne permettent pas de créer un profil personnel identifiable.
      </p>
      <SubTitle>Quels cookies utilisons-nous</SubTitle>
      <p className="my-4">
        <span className="font-semibold">Cloudflare</span> est utilisé pour rendre cette boutique en ligne aussi sûre et
        rapide que possible sur votre écran. Pour ce faire, certains cookies sont utilisés. Pour plus d'informations sur
        le fonctionnement de ces cookies, veuillez consulter la politique en matière de cookies de Cloudflare.
      </p>
      <p className="my-4">
        Nous utilisons également des cookies <span className="font-semibold">Splitbee</span>. Nous utilisons des cookies
        Splitbee pour collecter des données sur votre visite sur notre site web. Pour plus d'informations sur le
        fonctionnement de ces cookies, vous pouvez consulter la politique de confidentialité et la politique en matière
        de cookies de Splitbee.
      </p>
      <UnorderedList>
        <div>sb_uid</div>
      </UnorderedList>
    </div>
  );
};
